import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const msalConfigured = !!process.env.REACT_APP_MSAL_CLIENT_ID;

/**
 * Inner component that uses MSAL hooks (must be rendered inside MsalProvider).
 */
const MsalProtectedContent: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  if (!isAuthenticated) {
    const handleLogin = () => {
      // Save current path for redirect after login (handled by MsalRedirectHandler in App.tsx)
      sessionStorage.setItem('msalRedirectPath', window.location.pathname + window.location.search);
      instance.loginRedirect(loginRequest);
    };

    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
          <h2 className="text-2xl font-serif font-bold text-primary-800 mb-4">Admin Login</h2>
          <p className="text-gray-600 mb-6">
            Bitte melden Sie sich mit Ihrem Microsoft-Konto an, um auf den Adminbereich zuzugreifen.
          </p>
          <button
            onClick={handleLogin}
            className="bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-lg transition"
          >
            Mit Microsoft anmelden
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  if (!msalConfigured) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
          <h2 className="text-2xl font-serif font-bold text-primary-800 mb-4">Admin</h2>
          <p className="text-gray-600">
            Authentifizierung ist nicht konfiguriert. Bitte setzen Sie <code>REACT_APP_MSAL_CLIENT_ID</code> in der <code>.env</code> Datei.
          </p>
        </div>
      </div>
    );
  }

  return <MsalProtectedContent>{children}</MsalProtectedContent>;
};

export default ProtectedRoute;
